module.exports = __webpack_public_path__ + "img/62.653c478b.jpg";